import { render, staticRenderFns } from "./solution-2.vue?vue&type=template&id=39327f2a&"
import script from "./solution-2.vue?vue&type=script&lang=js&"
export * from "./solution-2.vue?vue&type=script&lang=js&"
import style0 from "./solution-2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports